import React from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked"; // Circle
import Tooltip from "@mui/material/Tooltip";
import RectangleOutlinedIcon from '@mui/icons-material/RectangleOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import SquareOutlinedIcon from '@mui/icons-material/SquareOutlined';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';

const shapeOptions = [
//   { name: "circle", icon: <CircleOutlinedIcon  /> },
//   { name: "square", icon: <SquareOutlinedIcon  /> },
//  // { name: "triangle", icon: <ChangeHistoryIcon /> },
//   { name: "heart", icon: <FavoriteBorderOutlinedIcon  /> },
//   { name: "rectangle", icon: <RectangleOutlinedIcon /> },
 { name: "circle",    icon: <CircleOutlinedIcon />,          ready: true  },
  { name: "square",    icon: <SquareOutlinedIcon />,          ready: false },
  { name: "heart",     icon: <FavoriteBorderOutlinedIcon />,  ready: false },
  { name: "rectangle", icon: <RectangleOutlinedIcon />,       ready: false },
];

const ShapeSelector = ({ selectedShape, setSelectedShape }) => {
  // const handleChange = (event, newValue) => {
  //   setSelectedShape(newValue);
  // };
  const handleChange = (event, newValue) => {
  const sel = shapeOptions.find(s => s.name === newValue);
  if (!sel || !sel.ready) return; // ignore clicks on disabled tabs
  setSelectedShape(newValue);
};

  return (
    <Box sx={{ width: "100%", mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        Select Shape:
      </Typography>

      
     <Tabs
  value={selectedShape}
  onChange={handleChange}
  variant="scrollable"
  scrollButtons="auto"
  aria-label="shape selection tabs"
  sx={{
    borderBottom: 1,
    borderColor: "divider",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
  }}
>
  {shapeOptions.map((shape) => {
    const disabled = !shape.ready;
    const label = shape.name.charAt(0).toUpperCase() + shape.name.slice(1);
    return (
      <Tooltip
        key={shape.name}
        title={disabled ? "This shape is under development. Only Circle is supported now." : ""}
        arrow
      >
        {/* Tooltip disabled elements-க்கு trigger ஆகாது; அதனால span-ல் wrap */}
        <span style={{ display: "inline-flex" }}>
          <Tab
            label={label}
            icon={shape.icon}
            iconPosition="start"
            value={shape.name}
            disabled={disabled}
            aria-disabled={disabled ? "true" : undefined}
          
             sx={{
    textTransform: "capitalize",
    fontWeight: "bold",
    opacity: disabled ? 0.6 : 1,
    cursor: disabled ? "not-allowed" : "pointer",
     
  }}
          />
        </span>
      </Tooltip>
    );
  })}
</Tabs>

    </Box>
  );
};

export default ShapeSelector;

